export let Integration;
(function (Integration) {
  Integration["Wordpress"] = "wordpress";
  Integration["Wpforms"] = "wpforms";
  Integration["Shopify"] = "shopify";
  Integration["Typeform"] = "typeform";
  Integration["ShopifyEmbedded"] = "shopify-embedded";
  Integration["GoogleWorkspaceApp"] = "google-workspace-app";
  Integration["ClaudeConnector"] = "claude-connector";
  Integration["ChatGptConnector"] = "chat-gpt-connector";
})(Integration || (Integration = {}));